import React from 'react';

/**
 * EmptyState — shown when a list/table has no data.
 */
export const EmptyState = ({
  icon,
  title = 'Nothing here yet',
  description,
  action,
  className = '',
  size = 'md',
}) => {
  const paddings = size === 'sm' ? 'py-8' : size === 'lg' ? 'py-20' : 'py-14';
  return (
    <div className={`w-full flex flex-col items-center justify-center text-center ${paddings} ${className}`}>
      <div className="w-14 h-14 rounded-2xl bg-primary-50 text-primary-600 flex items-center justify-center mb-4">
        {icon || (
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9 13h6m-3-3v6m9-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        )}
      </div>
      <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-slate-500 max-w-md">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
};

export default EmptyState;
